/* ============================================================
   ASK JAX — B&J AI Stylist Chat Widget
   Include: <script src="ask-jax.js"></script> before </body>
   ============================================================ */
(function () {
  // Production: jax-server on Hetzner VPS via Cloudflare Tunnel
  const API = "https://operates-fusion-non-lanes.trycloudflare.com/api/jax";
  const HISTORY_KEY = "bj-jax-history";

  // ---------- Styles ----------
  const css = `
  #jax-fab {
    position:fixed; bottom:24px; right:24px; z-index:9998;
    width:64px; height:64px; border-radius:50%; border:none; cursor:pointer;
    background:linear-gradient(135deg,#DEC6C4 0%,#c9a8a6 100%);
    box-shadow:0 8px 30px rgba(15,61,46,.35), 0 0 0 3px rgba(255,255,255,.15);
    font-size:26px; display:flex; align-items:center; justify-content:center;
    transition:transform .25s cubic-bezier(.34,1.56,.64,1), box-shadow .25s;
  }
  #jax-fab:hover { transform:scale(1.08) rotate(-4deg); box-shadow:0 12px 40px rgba(15,61,46,.45), 0 0 0 3px rgba(255,255,255,.25); }
  #jax-fab .jax-pulse {
    position:absolute; inset:-4px; border-radius:50%;
    border:2px solid rgba(222,198,196,.6); animation:jaxPulse 2.6s ease-out infinite; pointer-events:none;
  }
  @keyframes jaxPulse { 0%{transform:scale(1);opacity:.8} 100%{transform:scale(1.45);opacity:0} }

  #jax-panel {
    position:fixed; bottom:100px; right:24px; z-index:9999;
    width:min(380px, calc(100vw - 32px)); height:min(600px, calc(100vh - 140px));
    background:#0F3D2E; border-radius:22px; overflow:hidden;
    box-shadow:0 25px 80px rgba(0,0,0,.45), 0 0 0 1px rgba(222,198,196,.25);
    display:flex; flex-direction:column;
    transform:translateY(20px) scale(.96); opacity:0; pointer-events:none;
    transition:transform .3s cubic-bezier(.34,1.3,.64,1), opacity .25s;
    font-family:'Inter',system-ui,sans-serif;
  }
  #jax-panel.open { transform:translateY(0) scale(1); opacity:1; pointer-events:auto; }

  .jax-head {
    background:linear-gradient(135deg,#DEC6C4,#c9a8a6); padding:14px 16px;
    display:flex; align-items:center; gap:12px; flex-shrink:0;
  }
  .jax-avatar {
    width:42px; height:42px; border-radius:50%; background:#0F3D2E;
    display:flex; align-items:center; justify-content:center;
    font-family:'Cormorant Garamond',serif; font-size:20px; color:#DEC6C4; font-style:italic;
    box-shadow:inset 0 0 0 2px rgba(222,198,196,.5);
  }
  .jax-head-text { flex:1; min-width:0; }
  .jax-head-name { font-family:'Cormorant Garamond',serif; font-size:1.25rem; color:#0F3D2E; font-weight:600; line-height:1.1; }
  .jax-head-sub { font-size:.72rem; color:rgba(15,61,46,.75); letter-spacing:.04em; }
  .jax-close { background:none; border:none; color:#0F3D2E; font-size:20px; cursor:pointer; opacity:.7; padding:4px; line-height:1; }
  .jax-close:hover { opacity:1; }

  .jax-body { flex:1; overflow-y:auto; padding:16px 14px; display:flex; flex-direction:column; gap:12px; scrollbar-width:thin; scrollbar-color:rgba(222,198,196,.4) transparent; }
  .jax-body::-webkit-scrollbar { width:5px; }
  .jax-body::-webkit-scrollbar-thumb { background:rgba(222,198,196,.35); border-radius:3px; }

  .jax-msg { max-width:85%; padding:10px 14px; border-radius:16px; font-size:.9rem; line-height:1.5; white-space:pre-wrap; word-break:break-word; }
  .jax-msg.bot { background:rgba(222,198,196,.14); color:#f3ece6; border-bottom-left-radius:4px; align-self:flex-start; }
  .jax-msg.user { background:#DEC6C4; color:#0F3D2E; border-bottom-right-radius:4px; align-self:flex-end; }

  .jax-typing { display:flex; gap:5px; padding:12px 16px; align-self:flex-start; }
  .jax-typing span { width:7px; height:7px; border-radius:50%; background:#DEC6C4; opacity:.5; animation:jaxDot 1.2s infinite; }
  .jax-typing span:nth-child(2){ animation-delay:.15s } .jax-typing span:nth-child(3){ animation-delay:.3s }
  @keyframes jaxDot { 0%,60%,100%{transform:translateY(0);opacity:.4} 30%{transform:translateY(-5px);opacity:1} }

  .jax-product {
    align-self:flex-start; width:calc(100% - 10px); max-width:100%; background:rgba(255,255,255,.07);
    border:1px solid rgba(222,198,196,.3); border-radius:16px; overflow:hidden;
    display:flex; flex-direction:column; padding:0; align-items:stretch;
    transition:background .2s;
  }
  .jax-product:hover { background:rgba(255,255,255,.12); }
  .jax-product img { width:100%; height:200px; object-fit:cover; display:block; background:#fff; }
  .jax-product-info { padding:14px 16px; }
  .jax-product-name { font-size:1.05rem; color:#f3ece6; font-weight:600; line-height:1.3; margin-bottom:4px; }
  .jax-product-price { font-size:.95rem; color:#DEC6C4; font-weight:600; }
  .jax-product-link {
    display:block; text-align:center; margin-top:10px; font-size:.85rem; font-weight:700; letter-spacing:.06em;
    color:#0F3D2E; background:#DEC6C4; padding:10px 16px; border-radius:24px; text-decoration:none;
    transition:transform .15s, background .15s;
  }
  .jax-product-link:hover { transform:scale(1.04); background:#e8d5d3; }

  .jax-foot { padding:12px; display:flex; gap:8px; background:rgba(0,0,0,.18); flex-shrink:0; }
  .jax-input {
    flex:1; background:rgba(255,255,255,.1); border:1px solid rgba(222,198,196,.3);
    border-radius:24px; padding:11px 16px; color:#f3ece6; font-size:.88rem; outline:none;
    font-family:'Inter',sans-serif; transition:border-color .2s, background .2s;
  }
  .jax-input::placeholder { color:rgba(243,236,230,.45); }
  .jax-input:focus { border-color:#DEC6C4; background:rgba(255,255,255,.14); }
  .jax-send {
    width:44px; height:44px; border-radius:50%; border:none; cursor:pointer; flex-shrink:0;
    background:#DEC6C4; color:#0F3D2E; font-size:17px; display:flex; align-items:center; justify-content:center;
    transition:transform .15s;
  }
  .jax-send:hover { transform:scale(1.08); }
  .jax-send:disabled { opacity:.5; cursor:default; transform:none; }

  @media (max-width:480px){
    #jax-panel { bottom:0; right:0; left:0; width:100%; height:82vh; border-radius:22px 22px 0 0; }
    #jax-fab { bottom:18px; right:18px; }
  }`;

  const style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  // ---------- DOM ----------
  const fab = document.createElement("button");
  fab.id = "jax-fab";
  fab.setAttribute("aria-label", "Chat with Jax");
  fab.innerHTML = `✦<span class="jax-pulse"></span>`;

  const panel = document.createElement("div");
  panel.id = "jax-panel";
  panel.innerHTML = `
    <div class="jax-head">
      <div class="jax-avatar">J</div>
      <div class="jax-head-text">
        <div class="jax-head-name">Ask Jax</div>
        <div class="jax-head-sub">your B&J stylist ✦ always on</div>
      </div>
      <button class="jax-close" aria-label="Close">✕</button>
    </div>
    <div class="jax-body" id="jax-body"></div>
    <div class="jax-foot">
      <input class="jax-input" id="jax-input" placeholder="Ask me anything…" autocomplete="off" />
      <button class="jax-send" id="jax-send" aria-label="Send">➤</button>
    </div>`;

  document.body.appendChild(fab);
  document.body.appendChild(panel);

  const body = panel.querySelector("#jax-body");
  const input = panel.querySelector("#jax-input");
  const sendBtn = panel.querySelector("#jax-send");

  // ---------- State ----------
  let history = [];
  try {
    const raw = JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]");
    // Validate: must be array of {role, content} strings — drop anything malformed
    if (Array.isArray(raw)) {
      history = raw.filter(m => m && typeof m.role === "string" && typeof m.content === "string" && m.content.length < 4000);
    }
  } catch (e) { history = []; }
  let busy = false;

  function save() {
    try { localStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(-20))); } catch (e) {}
  }

  function scroll() { body.scrollTop = body.scrollHeight; }

  function addMsg(text, who) {
    const d = document.createElement("div");
    d.className = "jax-msg " + who;
    // Render basic markdown: **bold**, *italic*, line breaks
    let html = text
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/\*(.+?)\*/g, "<em>$1</em>")
      .replace(/\n/g, "<br>");
    d.innerHTML = html;
    body.appendChild(d);
    scroll();
  }

  function addProduct(p) {
    const d = document.createElement("div");
    d.className = "jax-product";
    d.innerHTML = `
      ${p.img ? `<img src="${p.img}" alt="" loading="lazy">` : ""}
      <div class="jax-product-info">
        <div class="jax-product-name">${p.title}</div>
        <div class="jax-product-price">${p.price}</div>
        <a class="jax-product-link" href="${p.url}" target="_blank" rel="noopener">SHOP NOW →</a>
      </div>`;
    body.appendChild(d);
    scroll();
  }

  function showTyping() {
    const t = document.createElement("div");
    t.className = "jax-typing"; t.id = "jax-typing";
    t.innerHTML = "<span></span><span></span><span></span>";
    body.appendChild(t); scroll();
  }
  function hideTyping() {
    const t = document.getElementById("jax-typing");
    if (t) t.remove();
  }

  const GREETING = "Hey hey ✨ I'm Jax — your personal stylist here at Beverly & Jax. Tell me what you're looking for — a vibe, an occasion, a mood — and I'll find you something you'll love. What are we styling today?";

  async function send() {
    const text = input.value.trim();
    if (!text || busy) return;
    busy = true; sendBtn.disabled = true;
    input.value = "";
    addMsg(text, "user");
    history.push({ role: "user", content: text });
    save();
    showTyping();
    try {
      const res = await fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: history.slice(-12) }),
      });
      const data = await res.json();
      console.log("[jax] response:", JSON.stringify(data).slice(0, 500));
      console.log("[jax] products:", (data.products || []).length, data.products);
      hideTyping();
      if (data.reply) {
        addMsg(data.reply, "bot");
        history.push({ role: "assistant", content: data.reply });
      }
      (data.products || []).forEach(addProduct);
      save();
    } catch (e) {
      hideTyping();
      addMsg("Hmm, I lost my connection for a sec 😅 one more time?", "bot");
    }
    busy = false; sendBtn.disabled = false;
    input.focus();
  }

  // ---------- Events ----------
  fab.addEventListener("click", () => {
    panel.classList.toggle("open");
    if (panel.classList.contains("open") && body.children.length === 0) {
      addMsg(GREETING, "bot");
      history.push({ role: "assistant", content: GREETING });
      save();
    }
    if (panel.classList.contains("open")) input.focus();
  });
  panel.querySelector(".jax-close").addEventListener("click", () => panel.classList.remove("open"));
  sendBtn.addEventListener("click", send);
  input.addEventListener("keydown", (e) => { if (e.key === "Enter") send(); });

  // Replay history (text only — products are re-fetchable)
  history.forEach((m) => {
    if (m.role === "user") addMsg(m.content, "user");
    else if (m.role === "assistant") addMsg(m.content, "bot");
  });

  // ---------- Global trigger ----------
  // Any element with data-open-jax (or #open-jax) opens the chat panel.
  window.openJax = function () {
    if (!panel.classList.contains("open")) {
      panel.classList.add("open");
      if (body.children.length === 0) {
        addMsg(GREETING, "bot");
        history.push({ role: "assistant", content: GREETING });
        save();
      }
    }
    input.focus();
  };
  document.querySelectorAll("[data-open-jax]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      window.openJax();
    });
  });
})();
